/**
 * @todo Evaluate if the recipe is valid
 */
const evaluateIsRecipeValid = () => {
	return true;
}

export default evaluateIsRecipeValid;
